<template>
  <div class="flex flex-col items-center px-4 pt-2 pb-8 h-full justify-between">
    <div class="flex flex-col items-center h-fit">
      <div
        class="rounded-lg flex flex-col justify-center items-center bg-NAVY-BLUE relative px-4 pb-4 pt-2 h-[140px] w-[140px]"
      >
        <ItemFigure :image="itemInfo.image" black-shadow class="!w-fit object-contain"></ItemFigure>
        <div v-if="!itemInfo.isOwned" class="z-10 absolute right-2 top-2">
          <img src="@/assets/icons/lock.svg" class="w-5 h-5 object-contain" />
        </div>
        <div
          v-if="itemInfo.level"
          class="absolute bottom-2 right-2 border border-white bg-LIGHTGREY rounded-md z-10"
        >
          <p class="text-xl font-semibold text-PRIMARY px-[2px] py-[0.5px]">
            Lv.{{ itemInfo.level }}
          </p>
        </div>
      </div>
      <div class="flex flex-col">
        <p class="text-lg font-semibold pt-6">{{ itemInfo.name }}</p>
        <p class="text-sm font-normal pt-3">
          {{ itemInfo.description }}
        </p>
      </div>
    </div>

    <div class="flex flex-col gap-6 pt-3 items-center w-full pb-3">
      <div v-if="!itemInfo.isOwned && !itemInfo.isUsed" class="flex flex-row items-center gap-1">
        <p class="text-GREY text-xs pe-2">Price</p>
        <img class="w-5" src="@/assets/icons/token-2.svg" />
        <p class="font-semibold">{{ itemInfo.buy_price }}</p>
      </div>
      <div v-else class="flex flex-row items-center gap-1">
        <p class="text-GREY text-xs pe-2">Upgrade Price</p>
        <img class="w-5" src="@/assets/icons/token-2.svg" />
        <p class="font-semibold">{{ itemInfo.buy_price }}</p>
      </div>
      <pow-button
        secondary
        class="w-full"
        :loading="loading"
        :disabled="(gameStore.totalToken + gameStore.calculatedTotalToken) < itemInfo.price"
        @click="buyItem(itemInfo)"
      >
        <p>{{ itemInfo.level > 0 ? 'Upgrade' : 'Buy Item' }}</p>
      </pow-button>
      <pow-button v-if="itemInfo.isUsed" secondary class="w-full opacity-50" :loading="loading">
        <p>Current Item</p>
      </pow-button>
      <pow-button
        v-else-if="itemInfo.isOwned"
        tertiary
        class="w-full"
        :loading="loading"
        @click="use(itemInfo)"
      >
        <p>Use Item</p>
      </pow-button>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import PowButton from '@/components/PowButton.vue'
import ItemFigure from '../ItemFigure.vue'
import { updateSkin, changeCharacterOrSkin } from '@/services'
import { useGameStore } from '@/stores/game'
import { closeBottomDrawer } from '@/composables/bottomdrawer'

const gameStore = useGameStore()

const props = defineProps({
  itemInfo: {
    type: Object,
    required: true
  }
})
const loading = ref(false)

const buyItem = async (item) => {
  loading.value = true
  const action = item.level > 0 ? 'upgrade' : 'buy'

  const res = await updateSkin({
    action,
    id: item.id
  })
  gameStore.fetchUserSync()
  closeBottomDrawer()
  loading.value = false
}

const use = async (skin) => {
  loading.value = true
  const res = await changeCharacterOrSkin({ id: skin.id, action: 'change_skin' })
  if (res.data == 'ok') {
    // gameStore.activeCharacterId = skin.id
    gameStore.activeSkins[skin.type] = skin
  }
  closeBottomDrawer()
  loading.value = false
}
</script>
